/* eslint-disable */

export const getDepthBotConstants = {
    GET_DEPTH_BOT_REQUEST: 'GET_DEPTH_BOT_REQUEST',
    GET_DEPTH_BOT_SUCCESS: 'GET_DEPTH_BOT_SUCCESS',
    GET_DEPTH_BOT_FAILURE: 'GET_DEPTH_BOT_FAILURE',
};
